import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'app-tag-list',
    templateUrl: './tag-list.component.html',
    styleUrls: ['./tag-list.component.css']
})
export class TagListComponent implements OnInit {
    @Input() tags: Array<string>;
    @Input() selectedTags: Array<string> = new Array();
    @Output() toggle = new EventEmitter();

    constructor() {
    }

    ngOnInit() {
    }

    toggleTag(tag) {
        let isSelected = this.selectedTags.indexOf(tag) > -1;
        isSelected = !isSelected;
        console.log('tag and isSelected inside TagListComponent:', tag, isSelected);
        this.toggle.emit({tag: tag, selected: isSelected});
    }
}



// WEBPACK FOOTER //
// ./src/app/tags/tag-list/tag-list.component.ts